export const uiAlarmMixin = {
  computed: {
    triggeredAlarms() {
      if (this.alarms === undefined) {
        console.error(
          "[uiAlarmMixin] Missing alarms in data of the component please fix this"
        );
        return [];
      }
      return (
        this.alarms
          .filter((alarm) => alarm.active)
          .filter((alarm) => {
            const isAlarmActive = alarm.activeAlarms.length > 0;
            return isAlarmActive || alarm.flagging;
          })
          .sort((a, b) => {
            return b.activeAlarms.length - a.activeAlarms.length;
          }) ?? []
      );
    },
  },
};
